module.exports = __webpack_public_path__ + "img/syrups-powders.829b6884.jpg";